import { COMPANY } from "../../data/site";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0F1C]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 rounded-sm border border-[var(--accent)] flex items-center justify-center text-gold font-display text-lg">
                A
              </span>
              <span className="font-display text-xl text-[var(--text)]">{COMPANY.name}</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Certified financial planning by {COMPANY.planner}. Mutual Funds, SIPs & Specialized
              Investment Funds — built around your life.
            </p>
          </div>

          <div>
            <div className="overline mb-4">Explore</div>
            <div className="flex flex-col gap-3">
              {["Services", "Approach", "Calculators", "About", "Contact"].map((l) => (
                <button
                  key={l}
                  data-testid={`footer-${l.toLowerCase()}`}
                  onClick={() => go(`#${l.toLowerCase()}`)}
                  className="text-left text-white/60 hover:text-gold transition-colors text-sm"
                >
                  {l}
                </button>
              ))}
            </div>
          </div>

          <div>
            <div className="overline mb-4">Reach us</div>
            <div className="flex flex-col gap-3 text-sm text-white/60">
              <a href={`tel:${COMPANY.phone}`} className="hover:text-gold transition-colors">{COMPANY.phone}</a>
              <a href={`mailto:${COMPANY.email}`} className="hover:text-gold transition-colors">{COMPANY.email}</a>
              <span>{COMPANY.address}</span>
            </div>
          </div>
        </div>

        <div className="hairline my-10" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/40">
          <p>&copy; {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <p className="max-w-md text-center sm:text-right">
            Mutual fund investments are subject to market risks. Read all scheme related documents
            carefully.
          </p>
        </div>
      </div>
    </footer>
  );
};
